const transformNumber = (value: number | string): string => {
  if (!parseFloat(value as string)) {
    return '';
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export { transformNumber };
